import { BaseService } from './BaseService';
import createSignedUploadUrlQuery from '../graphql/mutations/CreateSignedUploadUrl.gql';

class SignedUploadService extends BaseService {
  /**
   * Generate a signed url for upload and do the actions.
   * if the upload fails. the return primise fails too
   *
   * @param  {File}         file File to upload
   * @return {Promise<any>}      Promise that will be executed after uploads finish
   */
  public startClientUpload(file: File): Promise<any> {
    return this.generateSignedUploadUrl(file.name).then((response: any) => {
      const content = response.data.generateSignedUploadUrl;
      const fields = JSON.parse(content.serializedFields);

      return this.uploadFileToSignedUrl(file, content.url, fields).then(() => {
        if (response.data.generateSignedUploadUrl) {
          return JSON.parse(response.data.generateSignedUploadUrl.serializedFields);
        }
        // @TODO Error handling
      });
    });
  }

  /**
   * Call a graphql mutation to generate a signed upload url from fileName
   *
   * @param  {string}          fileName Name of the file to upload
   * @return {Promise<object>}          Returned promise from graphql
   */
  public generateSignedUploadUrl(fileName: string): Promise<any> {
    return this.client.mutate({
      mutation: createSignedUploadUrlQuery,
      variables: { fileName }
    });
  }

  /**
   * Send the formdata object the the url through a POST request
   *
   * @param  {File}        file File to upload
   * @param  {string}      url      Endpoint for the signed url upload
   * @param  {any}         fields   Object containing all the required data to
   *                                add into a formData to allow the upload
   * @return {Promise<any>}         Promise resolving the signed upload
   */
  public uploadFileToSignedUrl(file: File, url: string, fields: any): Promise<any> {
    const formData = new FormData();

    formData.append('key', fields.key);
    delete fields.key;

    for (const i in fields) {
      if (Object.prototype.hasOwnProperty.call(fields, i)) {
        formData.append(i, fields[i]);
      }
    }

    formData.append('file', file);

    return this.httpClient(url, {
      method: 'POST',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
}

export const signedUploadService = new SignedUploadService();
